jQuery( document ).ready(function($) {

  if($('.coursfiltre').length > 0) {
    $('.owl-carousel').owlCarousel({
      loop:true,
      nav:true,
      dots: false,
      navText : ["<i class='fa fa-chevron-left'></i>","<i class='fa fa-chevron-right'></i>"],
      responsive:{
        0:{
          items:1,
          nav:false,
          autoplay:true,
          autoplayTimeout:4000,
        },
        600:{
          items:2
        },
        1000:{
          items:3
        },
        1440:{
          items:4
        }
      }
    })

    $('.coursfiltre_item').on('click', (e) => {
      
      $('.coursfiltre_item').removeClass('coursfiltre_item-active')
      $('.coursfiltre_bar').removeClass('coursfiltre_bar-active')
      $(e.currentTarget).addClass('coursfiltre_item-active')
      $(e.currentTarget).find('.coursfiltre_bar').addClass('coursfiltre_bar-active')
      let type = $(e.currentTarget).attr('data-id')
      if ( type == 'multi' ) {
        $('.coursfiltre_mono .owl-stage-outer').hide();
        $('.coursfiltre_mono .owl-nav').hide();
        $('.coursfiltre_multi .owl-stage-outer').show();
        if ($(window).width() > 425) {
          $('.coursfiltre_multi .owl-nav').show();
        }
      }
      else {
        $('.coursfiltre_mono .owl-stage-outer').show();
        if ($(window).width() > 425) {
          $('.coursfiltre_mono .owl-nav').show();
        }
        $('.coursfiltre_multi .owl-stage-outer').hide();
        $('.coursfiltre_multi .owl-nav').hide();
      }
    })

  }
});

